<script setup lang="ts">
defineProps<{
  areProductsLoading: boolean;
  productCount?: number;
}>();
</script>

<template>
  <BaseStickyFilterBar>
    <template #title>
      <h1
        v-if="!areProductsLoading"
        class="mr-auto uppercase"
      >
        {{
          $t(
            "productsOverviewBlock.productsCount",
            {
              PLACEHOLDER_amount: productCount,
            },
            {
              plural: productCount,
            },
          )
        }}
      </h1>
    </template>

    <template #filter>
      <slot />
    </template>
  </BaseStickyFilterBar>
</template>
